import { Component, Input, type OnInit, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'

export function createMultiUnitSettingsForm(fb: UntypedFormBuilder) {
  return fb.group({
    auto_assign: ['created'],
    days: [0, [Validators.min(0)]],
    auto_compact: [false],
  })
}

@Component({
  selector: 'app-multi-unit-reservation-settings',
  templateUrl: './multi-unit-reservation-settings.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MultiUnitReservationSettingsComponent implements OnInit {
  @Input() form: UntypedFormGroup
  constructor() {}

  ngOnInit(): void {}
}
